require('./bootstrap');
require('./modules/staffMembersController');
require('./modules/cookie');

import WaveSurfer from 'wavesurfer.js';

require('./modules/newsletterController');
// require('./modules/masonry');

// require('WaveSurfer');
// require('ekko-lightbox');
// require('jquery-cookiebar');

$( document ).ready(function() {

    const waveforContainer = $("#waveform");
    const playBtn = $(".btn-play");

    if(waveforContainer.length){

        let wavesurfer = WaveSurfer.create({
            container: '#waveform',
            backend: 'MediaElement',
            barHeight: 1, // the height of the wave
            waveColor: '#D8D8D8',
            progressColor: '#98694B',
            cursorColor: '#D8D8D8',
            barWidth: 3,
            barRadius: 3,
            cursorWidth: 1,
            height: 40,
            barGap: 3
        });

        wavesurfer.load( waveforContainer.data('audio') );

        playBtn.on('click touch', function() {
            wavesurfer.playPause();
        });

        // wavesurfer.on('audioprocess', function () {
            // console.log(wavesurfer.getCurrentTime() + "/" + wavesurfer.getDuration())
        // });

        // wavesurfer.on('audioprocess', function() {
            // if (wavesurfer.isPlaying()) {
                // var totalTime = wavesurfer.getDuration(),
                    // currentTime = wavesurfer.getCurrentTime(),
                    // remainingTime = totalTime - currentTime;

                // document.getElementById('podcastTime').innerText = Math.round(currentTime) + " / " + Math.round(totalTime);
                // document.getElementById('podcastTime').innerText = $scope.getCurrentDuration();;

            // }
        // });
    }

    let correctCaptcha = function(response) {
        alert(response);
    };

	$("#searchInput").on("keyup", function() {
		let value = $(this).val().toLowerCase();
		$(".section").filter(function() {
			const titleIsFinded = $(this).find('.title').text().toLowerCase().indexOf(value);
			const subtitleIsFinded = $(this).find('.subtitle').text().toLowerCase().indexOf(value);
			$(this).toggle( titleIsFinded > -1 || subtitleIsFinded > -1 )
		});
	});


	const navbarContent = $('#navbarContent');
    navbarContent.on('hide.bs.collapse', function () {
        $('.hamburger').toggleClass('is-active');
    });
    navbarContent.on('show.bs.collapse', function () {
        $('.hamburger').toggleClass('is-active');
    });

    $('#selectMonth').bind("change keyup",function() {
      window.location = $(this).val();
    });

    $('.carousel').carousel({
        interval: 15000
    });

	$("#sendMail").on("click", function() {
        grecaptcha.enterprise.ready(async () => {
            const token = await grecaptcha.enterprise.execute('6LcVqwIqAAAAAP-ei9UPfbRNytEWXJAFyswD8vMl', {action: 'LOGIN'}).then(function(token) {

                if ($("#contactForm")[0].checkValidity()){

                    const url = $("#contactForm").attr('action');
                    const formData = $("#contactForm").serialize();

                    $.ajax({
                        url: url,
                        type: 'POST',
                        dataType: 'json',
                        data: formData,
                    })
                        .done(function(data) {
                            $('#sendMessage').html(data.message);
                            $("#contactForm").trigger("reset");
                        })
                        .fail(function() {
                            $('#sendMessage').html('<p>The operation failed. Please try again!<p>');
                        })
                        .always(function() {

                        });
                } else {
                    $("#contactForm")[0].reportValidity();

                }
            });
        });

        return false;
	})
});
